import {
  datadogRum,
  DefaultPrivacyLevel,
  RumGlobal,
  RumInitConfiguration,
} from "@datadog/browser-rum";
import { addConsentListener, getConsentState } from "../oneTrust/oneTrust";

let consentListenerId: Symbol | null = null;

const configureRumInstance = (config: RumInitConfiguration) => {
  const fixedConfigurations = {
    sessionSampleRate: 100,
    sessionReplaySampleRate: 0,
    defaultPrivacyLevel: DefaultPrivacyLevel.MASK,
  };

  datadogRum.init({
    ...config,
    ...fixedConfigurations,
  });
};

/**
 * Init Real User Monitoring from DataDog. Currently supporting sdk version ^6.3.0
 * for a full list of configuration refer to the DataDog documentation
 * https://docs.datadoghq.com/real_user_monitoring/browser/
 *
 * This methods automatically enforce user tracking and cookie consent meaning that
 * reporting might turn off/on itself depending on users preferences.
 *
 * @param initConfiguration initial configuration
 */
export function initializeRum(initConfiguration: RumInitConfiguration) {
  const { hasAnalyticsConsent } = getConsentState();
  if (hasAnalyticsConsent) {
    configureRumInstance(initConfiguration);
  }

    consentListenerId ??= addConsentListener(
      ({ hasAnalyticsConsent: consent }) => {
        if (consent) configureRumInstance(initConfiguration);
        else datadogRum.setTrackingConsent("not-granted");
      }
    );
}

/**
 * Returns the instance of the datadogRum object.
 *
 * @returns datadogRum instance
 */
export function getDatadogRumInstance(): RumGlobal {
  return datadogRum;
}
